import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMarketName } from '../../app/selectors';
import {
  getIngredientsByFilter,
  getIsExcludedFetching,
  getIsExcludedFetched
} from '../selectors';
import { fetchExcludedIngredients } from '../actions';

/**
 * Get data for excluded ingredients.
 *
 * @returns {[boolean, *]}
 */
// Consider if useIngredients, useExcludedIngredients and useGlobalIngredients
// should be merged into one hook to make this easier.
const useExcludedIngredients = ({ itemCode = null } = {}) => {
  const [notStartedFetching, setNotStartedFetching] = useState(true);
  const dispatch = useDispatch();
  const isFetchingIngredients = useSelector(getIsExcludedFetching);
  const isFetched = useSelector(getIsExcludedFetched);
  const userOrganization = useSelector(getMarketName);
  const isFetching = notStartedFetching ? true : isFetchingIngredients;
  const ingredients = useSelector(
    getIngredientsByFilter({
      itemCode,
      // owningOrganization: userOrganization,
      hasPpi: false,
      isExcluded: true,
      userOrganization
    })
  );

  useEffect(() => {
    if (!isFetched) {
      dispatch(fetchExcludedIngredients());
    }
    setNotStartedFetching(false);
  }, [dispatch, isFetched, setNotStartedFetching]);

  return [isFetched ? false : isFetching, ingredients];
};

export default useExcludedIngredients;
